// extracted by mini-css-extract-plugin
export const sectionRoot = "styles-module--sectionRoot--DU4Lk";
export const container = "styles-module--container--L9f2x";
export const card = "styles-module--card--rPd8O";
export const cardLink = "styles-module--cardLink--ohiM1";
export const logo = "styles-module--logo--yATiC";
export const txtCompanyName = "styles-module--txtCompanyName--8It7R";
export const txtMaxCashback = "styles-module--txtMaxCashback--H1qW2";